/**
 * Copyright IBM Corp. 2025, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { html, svg } from 'lit';
import { prefix } from '../../../globals/settings';

const componentName = 'full-page-error';
const blockClass = `${prefix}--${componentName}`;

const innerSVG = svg`<g clipPath="url(#clip0_0_2401)">
    <path
      d="M555.347 83.237H485.983V152.601H555.347V83.237Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M512.922 117.919H528.408"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M520.665 110.176V125.662"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M541.474 138.29L549.525 165.13L554.896 157.079L564.29 166.474L569.658 161.107L560.263 151.712L568.314 146.341L541.474 138.29Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M488.445 101.883C498.022 101.883 505.786 94.1191 505.786 84.5419C505.786 74.9647 498.022 67.2009 488.445 67.2009C478.868 67.2009 471.104 74.9647 471.104 84.5419C471.104 94.1191 478.868 101.883 488.445 101.883Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M482.662 78.763L494.224 90.3208"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M494.224 78.763L482.662 90.3208"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path d="M236.272 208.092H749.566V520.231H555.347" fill="#F3F3F3" />
    <path
      d="M236.272 208.092H749.566V520.231H555.347"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M145.053 328.006V319.318"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M127.63 313.509L121.821 319.318"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M162.477 313.509L168.286 319.318"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M145.053 121.387V278.662"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M167.553 307.699C168.03 305.844 168.286 303.897 168.286 301.89C168.286 289.058 157.886 278.658 145.053 278.658C132.221 278.658 121.821 289.058 121.821 301.89C121.821 303.897 122.077 305.844 122.553 307.699H167.553Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M150.863 307.699C150.863 310.908 148.262 313.509 145.053 313.509C141.845 313.509 139.244 310.908 139.244 307.699H150.858H150.863Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M87.1387 492.486H83.6705V554.913H87.1387V492.486Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M121.821 551.445H48.9884V554.913H121.821V551.445Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M57.6546 568.786C60.5301 568.786 62.8612 566.457 62.8612 563.584C62.8612 560.711 60.5301 558.382 57.6546 558.382C54.779 558.382 52.4479 560.711 52.4479 563.584C52.4479 566.457 54.779 568.786 57.6546 568.786Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M75.0043 568.786C77.8799 568.786 80.211 566.457 80.211 563.584C80.211 560.711 77.8799 558.382 75.0043 558.382C72.1288 558.382 69.7977 560.711 69.7977 563.584C69.7977 566.457 72.1288 568.786 75.0043 568.786Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M116.614 568.786C119.49 568.786 121.821 566.457 121.821 563.584C121.821 560.711 119.49 558.382 116.614 558.382C113.739 558.382 111.407 560.711 111.407 563.584C111.407 566.457 113.739 568.786 116.614 568.786Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M40.3179 492.486H130.491C131.449 492.486 132.225 491.709 132.225 490.751V480.347C132.225 479.389 131.449 478.613 130.491 478.613H40.3179C39.3602 478.613 38.5838 479.389 38.5838 480.347V490.751C38.5838 491.709 39.3602 492.486 40.3179 492.486Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M132.36 549.98C132.36 549.811 132.308 549.642 132.212 549.503L128.887 544.517L127.118 537.585C127.118 534.711 124.79 532.383 121.916 532.383C119.042 532.383 116.714 534.711 116.714 537.585L115.014 547.986V550.587C115.014 551.064 115.405 551.454 115.881 551.454H131.493C131.974 551.454 132.36 551.064 132.36 550.587V549.984V549.98Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M114.113 551.454H142.725V549.72H114.113V551.454Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M116.15 541.053C116.15 541.053 117.863 542.051 120.186 542.276C121.578 542.41 123.494 541.036 123.494 541.036C123.494 541.036 125.384 539.315 127.118 539.315C127.647 539.315 128.957 540.082 129.889 541.235C130.114 541.513 130.617 542.202 131.272 542.887C131.415 543.035 131.562 543.178 131.705 543.316C132.264 543.841 135.685 544.179 137.003 544.517C140.055 545.302 141.863 546.824 141.863 549.72H114.984L114.997 547.986H114.984C114.984 544.517 116.15 541.053 116.15 541.053Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M123.494 541.036L128.757 544.509L136.999 544.517C132.36 543.871 130.331 541.786 129.884 541.235C128.952 540.082 127.647 539.315 127.114 539.315C125.38 539.315 123.49 541.036 123.49 541.036H123.494Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M108.85 567.312C108.85 567.143 108.798 566.974 108.702 566.835L105.377 561.85L103.608 554.918C103.608 552.043 101.28 549.715 98.4061 549.715C95.5318 549.715 93.2038 552.043 93.2038 554.918L91.5043 565.318V567.919C91.5043 568.396 91.8945 568.786 92.3714 568.786H107.983C108.464 568.786 108.85 568.396 108.85 567.919V567.316V567.312Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M90.6069 568.786H119.22V567.052H90.6069V568.786Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M92.6402 558.386C92.6402 558.386 94.3526 559.383 96.6763 559.608C98.0679 559.743 99.9841 558.368 99.9841 558.368C99.9841 558.368 101.874 556.647 103.608 556.647C104.137 556.647 105.447 557.415 106.379 558.568C106.604 558.845 107.107 559.535 107.762 560.22C107.905 560.367 108.052 560.51 108.195 560.649C108.754 561.173 112.175 561.512 113.493 561.85C116.545 562.634 118.353 564.156 118.353 567.052H91.474L91.487 565.318H91.474C91.474 561.85 92.6402 558.386 92.6402 558.386Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M99.9841 558.368L105.247 561.841L113.488 561.85C108.85 561.204 106.821 559.119 106.374 558.568C105.442 557.415 104.137 556.647 103.604 556.647C101.87 556.647 99.9797 558.368 99.9797 558.368H99.9841Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M56.8699 447.373H93.2861L125.718 449.436C128.931 450.212 136.136 451.201 135.694 461.267L132.225 537.568H111.416V478.608H55.9248L56.8699 447.369V447.373Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M35.1156 443.931C35.1156 443.931 35.1416 450.867 35.1416 457.405C35.1416 460.509 35.9436 463.171 37.0448 466.474C37.3049 467.259 38.5708 469.405 38.5708 469.405C40.1445 471.763 43.7254 475.201 49.565 477.039C59.8483 480.282 81.1517 483.815 81.1517 483.815L88.8772 554.913H107.952L105.529 474.694C105.225 470.948 103.097 467.593 99.8324 465.724L69.802 443.805L35.1199 443.926L35.1156 443.931Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M61.1271 376.275H76.3396C79.8078 376.275 91.2919 380.614 94.4263 382.097C97.0101 383.319 99.0607 385.73 99.6286 388.821C101.146 397.032 103.387 412.344 103.387 412.344L108.017 431.467C108.017 431.467 103.582 445.639 96.7587 445.639C93.2904 445.639 37.63 440.844 29.9349 440.462C27.88 440.358 23.8005 437.588 23.9913 433.227C24.5375 420.637 27.737 405.299 30.1517 390.633C30.906 386.042 34.6777 383.324 37.2615 382.643C42.9537 381.143 57.6676 376.279 61.1358 376.279L61.1271 376.275Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M139.912 431.749H133.21V438.685H139.912C139.912 438.685 143.38 440.419 145.114 440.419H153.386L153.451 430.014H148.582C148.582 430.014 150.802 428.731 151.227 428.636C151.652 428.545 155.519 429.304 155.519 426.546L151.283 426.438L146.077 427.045L140.146 431.749H139.912Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M154.613 424.812V428.714H150.277V438.251H154.613V440.419H166.751V424.812H154.613ZM154.613 436.951H151.578V430.014H154.613V436.951Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M154.552 439.517C154.379 440.068 153.867 440.419 153.316 440.419C153.316 440.419 153.299 440.419 153.269 440.419C153.156 440.419 153.035 440.397 152.918 440.358L152.658 440.237L149.84 438.915C149.384 438.767 149.133 438.282 149.28 437.822C149.428 437.367 149.913 437.116 150.368 437.263L151.682 437.506L153.316 437.809L153.403 437.827L153.711 437.883C153.936 437.957 154.131 438.082 154.279 438.251C154.582 438.581 154.699 439.062 154.552 439.517Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M153.711 437.883L153.403 437.827C153.507 437.831 153.611 437.848 153.711 437.883Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M154.179 435.65C154.179 436.37 153.594 436.951 152.879 436.951L147.676 436.517C147.195 436.517 146.809 436.132 146.809 435.65C146.809 435.169 147.195 434.783 147.676 434.783C147.676 434.783 146.376 434.77 146.376 433.738C146.376 432.975 146.762 432.616 147.243 432.616H148.27C148.171 432.173 148.457 431.688 148.886 431.527C149.51 431.293 151.244 430.578 151.244 430.578L152.285 430.162C152.285 430.162 152.766 430.014 152.874 430.014H152.879C153.451 430.014 153.971 430.392 154.132 430.968C154.283 431.527 154.053 432.1 153.594 432.399C153.945 432.633 154.179 433.032 154.179 433.483C154.179 433.934 153.945 434.337 153.594 434.566C153.945 434.801 154.179 435.199 154.179 435.65Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M208.526 440.462V568.786H194.653V450.867H14.3063V568.786H0.433502V440.462H208.526Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M208.526 440.436H194.653V440.462H208.526V440.436Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M91.539 413.566L93.8974 413.064L90.6113 397.903L91.539 413.566Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M76.0058 436.994H31.6474V440.462H76.0058V436.994Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M134.965 440.462H69.0693L87.1387 395.337H153.035L134.965 440.462Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M111.416 424.816C113.332 424.816 114.884 423.264 114.884 421.348C114.884 419.433 113.332 417.88 111.416 417.88C109.501 417.88 107.948 419.433 107.948 421.348C107.948 423.264 109.501 424.816 111.416 424.816Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M55.4219 363.546L59.2586 378.672C60.4378 383.315 65.1546 386.12 69.7933 384.945C74.4321 383.77 77.2413 379.049 76.0665 374.41L72.2297 359.285L55.4219 363.551V363.546Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M76.4783 346.777C74.8049 339.126 67.3309 334.162 59.5968 335.649C51.7413 337.158 46.5954 344.753 48.1084 352.608C48.4118 354.182 48.9624 355.643 49.7037 356.97H49.6951C49.6951 356.97 49.7297 357.03 49.7948 357.13C49.9725 357.438 50.1589 357.737 50.354 358.023C52.0361 360.698 56.4494 367.608 57.5549 368.358C59.2803 369.529 68.5751 372.503 70.9032 372.811C73.2312 373.119 74.7919 372.438 75.7933 371.471C77.1589 370.149 77.7312 367.014 77.8309 361.647C77.9046 357.798 77.1893 351.897 76.7731 348.815C76.7297 348.26 76.6604 347.701 76.552 347.142C76.539 347.068 76.5173 346.994 76.5043 346.916C76.4913 346.825 76.4826 346.777 76.4826 346.777H76.474H76.4783Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M75.7456 343.079C75.7196 343.019 75.7109 342.949 75.7196 342.884C75.7326 342.746 75.7283 342.607 75.7023 342.464C75.6372 342.134 75.4682 341.857 75.2341 341.649C75.1387 341.562 75.0953 341.432 75.1127 341.306C75.1344 341.15 75.1344 340.99 75.104 340.825C75.026 340.418 74.7832 340.088 74.4624 339.88C74.354 339.811 74.2846 339.689 74.2933 339.559C74.2976 339.447 74.2933 339.334 74.2716 339.221C74.1416 338.536 73.5477 338.059 72.8757 338.046C72.8757 338.038 72.8757 338.025 72.8757 338.016C72.75 337.353 72.182 336.884 71.5361 336.85C71.445 336.845 71.3583 336.876 71.2846 336.828C71.2586 336.811 71.2413 336.772 71.2326 336.733C71.0419 336.065 70.4046 335.623 69.7153 335.684C69.6676 335.684 69.5982 335.727 69.5029 335.671C69.4378 335.631 69.4378 335.527 69.3988 335.441C69.143 334.816 68.4754 334.435 67.7861 334.569C67.6777 334.591 67.5737 334.626 67.474 334.669C67.3092 334.747 67.1011 334.686 67.0101 334.53C66.7066 334.023 66.1127 333.733 65.5014 333.85C65.3193 333.884 65.1502 333.954 64.9985 334.049C64.8424 334.149 64.6387 334.088 64.5216 333.941C64.1965 333.533 63.6633 333.312 63.1127 333.421C62.8526 333.473 62.6271 333.59 62.4407 333.75C62.2673 333.902 62.0159 333.88 61.8685 333.707C61.5433 333.325 61.0274 333.126 60.5029 333.23C60.1864 333.29 59.9133 333.455 59.7138 333.676C59.5881 333.815 59.3714 333.828 59.224 333.72C58.9118 333.486 58.5086 333.377 58.0925 333.46C57.6633 333.542 57.3164 333.806 57.117 334.162C57.0086 334.353 56.7485 334.4 56.5708 334.27C56.2586 334.032 55.8468 333.923 55.4306 334.006C54.906 334.105 54.5029 334.478 54.3381 334.947C54.2644 335.15 54.0433 335.241 53.8396 335.163C53.5925 335.064 53.315 335.029 53.0332 335.085C52.487 335.189 52.0751 335.588 51.9234 336.082C51.867 336.269 51.6676 336.377 51.4768 336.342C51.3078 336.312 51.13 336.308 50.9523 336.342C50.3453 336.46 49.9031 336.941 49.8034 337.517C49.7731 337.699 49.604 337.838 49.4176 337.821C49.2919 337.812 49.1661 337.816 49.0361 337.842C48.3381 337.977 47.8526 338.592 47.8612 339.282C47.8612 339.368 47.8916 339.46 47.8309 339.577C47.8005 339.637 47.7355 339.65 47.6445 339.668C46.8598 339.819 46.3439 340.578 46.4956 341.363C46.5216 341.506 46.6127 341.579 46.578 341.723C46.5303 341.926 46.2789 341.948 46.1185 342.061C45.7153 342.347 45.5809 342.897 45.6763 343.392C45.6979 343.513 45.815 343.617 45.7933 343.734C45.763 343.921 45.5115 343.916 45.3468 344.055C44.9653 344.38 44.8786 344.788 44.9783 345.316C45.0043 345.447 45.104 345.555 45.1083 345.681C45.1083 345.863 44.9566 345.919 44.8872 345.984C44.6358 346.218 44.4754 346.556 44.6315 347.012C44.6488 347.055 44.6358 347.107 44.6228 347.155C44.1242 348.997 44.8612 354.815 46.5477 357.672C48.6156 361.171 52.2745 366.017 55.0274 369.03C55.7601 369.832 57.9884 373.647 57.9884 373.647L56.7095 368.605L55.4306 363.564C53.7485 363.988 52.0664 354.564 53.4364 355.04C53.6098 355.101 53.8872 355.509 54.2124 356.09C54.6633 356.9 55.8988 356.527 55.8338 355.604C55.604 352.353 52.4219 344.653 65.8656 341.241C71.7572 339.746 75.5505 344.15 76.6647 347.705C76.6647 347.705 76.5953 345.074 75.7543 343.101L75.7456 343.079Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M54.4205 356.688C53.7789 355.019 53.0332 354.256 51.9537 354.369C50.6878 354.503 50.1806 355.973 50.5491 357.16L51.8063 361.63C52.2095 362.931 53.6358 363.737 55.4219 363.542L54.4205 356.684V356.688Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M77.6228 365.749C77.3194 366.525 76.7211 367.188 75.9364 367.509L74.7009 368.012L72.8887 368.753L70.3786 369.78C69.013 370.34 67.617 369.642 67.2572 368.228C66.8974 366.815 67.7124 365.215 69.078 364.656L74.6358 362.384C76.0014 361.825 77.3974 362.523 77.7572 363.936C77.7962 363.221 77.8222 362.458 77.8396 361.639C77.8396 361.613 77.8396 361.587 77.8396 361.561C76.9118 360.793 75.6026 360.572 74.3107 361.101L68.7529 363.373C66.7066 364.21 65.1156 366.538 65.6532 368.658L66.3858 371.493C68.4928 372.746 71.5925 373.179 73.1835 372.776C73.4957 372.702 73.8121 372.611 74.1329 372.481C74.6662 372.264 75.1517 371.974 75.5939 371.653C75.6676 371.592 75.737 371.527 75.802 371.462C76.7731 370.526 77.341 368.662 77.6272 365.74L77.6228 365.749Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M73.3613 366.481C72.6503 366.772 72.1777 367.556 72.2428 368.332L72.3034 369.035L73.578 368.514L75.3902 367.773L75.117 367.157C74.8136 366.477 74.0722 366.191 73.3569 366.481H73.3613Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M62.4234 358.938C62.0636 358.47 61.3916 358.383 60.9234 358.747L56.2023 362.059C56.0159 362.207 55.8815 362.393 55.7948 362.597L54.5766 364.032C54.1777 364.843 54.2124 364.253 54.3295 363.858L55.5433 360.434L61.5347 357C62.0549 356.727 62.2587 356.077 61.9812 355.556C61.7081 355.032 61.0578 354.832 60.5376 355.11L55.0144 357.772C52.63 359.029 54.6676 357.776 54.9104 357.611L59.948 354.117C60.4422 353.796 60.5852 353.133 60.2644 352.639C59.9436 352.145 59.2803 352.001 58.7861 352.322L54.2948 355.014C49.8208 358.114 53.9393 355.049 54.1951 354.828L56.7052 352.669C57.1647 352.301 57.2428 351.629 56.8743 351.165C56.5058 350.705 55.8338 350.627 55.3699 350.996L49.3569 355.457C49.2095 355.578 49.0925 355.721 49.0101 355.882L45.3121 362.276L45.1691 362.488L48.091 357.464L41.2977 364.548C41.1069 364.838 40.9855 365.168 40.9509 365.514L40.0665 374.129C38.7659 376.101 39.3165 378.754 41.289 380.051C43.2615 381.351 45.9147 380.801 47.211 378.828C47.211 378.828 51.3468 376.431 52.526 374.645C53.7009 372.858 56.0506 369.286 56.0506 369.286C56.0982 369.208 56.1459 369.134 56.185 369.048L58.1532 363.91L62.2326 360.447C62.7009 360.087 62.7876 359.415 62.4234 358.947V358.938Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M23.7746 429.806C23.7746 429.806 36.5462 383.536 38.2413 375.811C38.4884 374.679 39.6546 374.012 40.7601 374.367L51.2601 377.09C52.1055 377.337 52.6084 378.204 52.4133 379.058L38.198 435.876C38.1633 436.019 38.1156 436.158 38.0506 436.283C36.0694 440.029 31.4523 441.533 27.6329 439.643C23.9696 437.831 22.3483 433.543 23.7832 429.802L23.7746 429.806Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path d="M319.509 445.665V258.382H666.329V319.075" fill="#F3F3F3" />
    <path
      d="M319.509 445.665V258.382H666.329V319.075"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M491.202 445.665H319.509V480.347H491.202V445.665Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path d="M648.988 480.347H491.202V445.665H669.798" fill="#F3F3F3" />
    <path
      d="M648.988 480.347H491.202V445.665H669.798"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M239.74 180.347H746.098C748.014 180.347 749.566 181.899 749.566 183.815V194.22H236.272V183.815C236.272 181.899 237.824 180.347 239.74 180.347Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M246.676 190.717C248.592 190.717 250.144 189.172 250.144 187.266C250.144 185.36 248.592 183.815 246.676 183.815C244.761 183.815 243.208 185.36 243.208 187.266C243.208 189.172 244.761 190.717 246.676 190.717Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M257.081 190.751C258.996 190.751 260.549 189.199 260.549 187.283C260.549 185.368 258.996 183.815 257.081 183.815C255.165 183.815 253.613 185.368 253.613 187.283C253.613 189.199 255.165 190.751 257.081 190.751Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M267.486 190.751C269.401 190.751 270.954 189.199 270.954 187.283C270.954 185.368 269.401 183.815 267.486 183.815C265.57 183.815 264.017 185.368 264.017 187.283C264.017 189.199 265.57 190.751 267.486 190.751Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M749.566 194.22H236.272V208.092H749.566V194.22Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M250.145 201.156H277.89"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M291.763 201.156H319.509"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M333.381 201.156H361.127"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M388.873 402.316C417.603 402.316 440.896 379.019 440.896 350.293C440.896 321.568 417.603 298.266 388.873 298.266C360.143 298.266 336.85 321.564 336.85 350.293C336.85 379.023 360.143 402.316 388.873 402.316Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M388.873 378.035C400.365 378.035 409.682 368.718 409.682 357.225C409.682 345.733 400.365 336.416 388.873 336.416C377.38 336.416 368.064 345.733 368.064 357.225C368.064 368.718 377.38 378.035 388.873 378.035Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M378.468 339.204V328.799C378.468 323.055 383.129 318.395 388.873 318.395C394.617 318.395 399.277 323.055 399.277 328.799V339.204"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M392.341 353.757C392.341 355.04 391.643 356.163 390.607 356.757V362.428C390.607 363.386 389.831 364.162 388.873 364.162C387.915 364.162 387.139 363.386 387.139 362.428V356.757C386.103 356.163 385.405 355.04 385.405 353.757C385.405 351.841 386.957 350.289 388.873 350.289C390.789 350.289 392.341 351.841 392.341 353.757Z"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M690.607 367.63H510.26V391.908H690.607V367.63Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M541.474 379.171H643.188"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M669.078 382.145L665.25 378.186L665.783 377.632L669.078 381.035L672.373 377.632L672.91 378.186L669.078 382.145Z"
      fill="black"
    />
    <path
      d="M690.607 312.139H510.26V336.416H690.607V312.139Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M522 323.679H643.188"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M669.078 326.653L665.25 322.695L665.783 322.14L669.078 325.543L672.373 322.14L672.91 322.695L669.078 326.653Z"
      fill="black"
    />
    <path
      d="M722.861 339.884H527.601V364.162H722.861V339.884Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M530.072 339.884H527.601V364.162H530.072V339.884Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M538.006 352.023H663.551"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M704.467 352.578L700.634 348.616L701.172 348.061L704.467 351.468L707.761 348.061L708.295 348.616L704.467 352.578Z"
      fill="black"
    />
    <path
      d="M704.467 351.468L708.295 355.431L707.761 355.986L704.467 352.578L701.172 355.986L700.634 355.431L704.467 351.468Z"
      fill="black"
    />
    <path
      d="M479.046 463.006H465.173"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M470.827 468.754L465.173 463.101L471.017 457.257"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M443.675 463.006H336.85"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M501.295 553.179C501.169 554.289 501.1 554.913 501.1 554.913V560.116H494.163V554.913C494.163 554.913 494.09 554.289 493.96 553.179H501.299H501.295Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M503.697 564.919V568.786H491.558V564.902C491.558 564.03 491.723 563.168 492.043 562.357L493.292 559.21C493.314 556.834 495.247 554.913 497.627 554.913C500.007 554.913 501.962 556.856 501.962 559.249L503.202 562.344C503.527 563.163 503.697 564.039 503.697 564.919Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M494.163 568.786H501.1V565.847H494.163V568.786Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M557.454 553.179L559.101 558.382L550.517 559.249L549.65 553.179H557.454Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M548.402 562.357L549.65 558.382V556.647C549.65 555.689 550.426 554.913 551.384 554.913H553.119C554.51 554.913 555.165 555.468 555.72 556.647C556.725 558.165 559.101 558.382 559.101 558.382C562.569 561.85 568.725 561.85 568.725 567.052V568.786H560.055H558.321H547.916V564.902C547.916 564.03 548.081 563.168 548.402 562.357Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M547.921 568.786H554.857V565.847H547.921V568.786Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M546.945 438.854L547.747 443.163L548.506 447.173C551.302 447.039 550.383 443.107 550.305 442.678C549.984 440.978 550.513 439.11 550.513 439.11L553.158 443.857L552.824 449.545L552.759 456.277C552.698 456.754 553.032 457.188 553.509 457.253C553.981 457.314 554.419 456.98 554.48 456.503L554.532 456.186C554.614 456.225 554.705 456.256 554.805 456.269C555.282 456.316 555.707 455.974 555.759 455.497L556.608 449.484L557.462 443.471C557.536 442.756 555.715 429.299 555.715 429.299L548.9 430.591L547.027 437.02C546.837 437.61 546.806 438.247 546.945 438.854Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M551.046 437.224C553.435 439.101 555.013 442.353 554.046 445.608L551.198 450.564C550.938 450.967 551.055 451.504 551.458 451.76C551.861 452.02 552.399 451.903 552.655 451.5L555.282 447.798L555.364 447.685L557.874 444.147C557.965 444.074 558.043 443.983 558.108 443.879C558.295 443.588 558.356 443.25 558.295 442.934C558.295 442.934 558.29 442.908 558.277 442.856C558.16 442.214 557.306 437.701 557.003 436.118C556.682 434.415 555.715 429.299 555.715 429.299C555.36 427.418 553.543 426.182 551.662 426.538C549.78 426.893 548.545 428.71 548.9 430.591C548.168 433.11 547.396 434.358 551.046 437.224Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M554.532 456.186L554.54 450.607"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M461.71 325.552C461.671 325.535 461.636 325.509 461.601 325.487C461.567 325.465 461.527 325.444 461.497 325.418C461.467 325.392 461.436 325.366 461.406 325.335C461.376 325.305 461.341 325.279 461.315 325.249C461.289 325.218 461.263 325.184 461.237 325.149C461.215 325.114 461.189 325.084 461.168 325.049C461.146 325.014 461.129 324.975 461.111 324.936C461.094 324.897 461.072 324.858 461.059 324.819C461.046 324.785 461.038 324.746 461.029 324.707C461.016 324.659 461.003 324.616 460.999 324.564C460.999 324.551 460.994 324.542 460.99 324.533C460.99 324.503 460.99 324.477 460.99 324.451C460.99 324.403 460.986 324.36 460.99 324.312C460.99 324.264 460.999 324.221 461.007 324.173C461.012 324.147 461.012 324.117 461.02 324.091C461.02 324.082 461.029 324.069 461.029 324.061C461.042 324.013 461.059 323.97 461.077 323.922C461.09 323.887 461.103 323.848 461.12 323.814C461.137 323.775 461.163 323.74 461.185 323.705C461.207 323.67 461.228 323.631 461.254 323.601C461.28 323.571 461.306 323.54 461.337 323.51C461.367 323.48 461.393 323.445 461.423 323.419C461.454 323.393 461.488 323.367 461.523 323.341C461.558 323.319 461.588 323.293 461.623 323.272C461.658 323.25 461.697 323.233 461.736 323.215C461.775 323.198 461.814 323.176 461.853 323.163C461.887 323.15 461.926 323.142 461.965 323.133C462.013 323.12 462.056 323.107 462.108 323.103C462.121 323.103 462.13 323.098 462.139 323.094L468.195 322.63C468.785 322.565 469.318 322.986 469.392 323.575V323.584C469.392 323.584 469.392 323.584 469.392 323.588L469.925 329.618C469.986 330.095 469.647 330.529 469.171 330.585C468.724 330.642 468.317 330.342 468.221 329.909L467.697 331.899C467.592 332.367 467.129 332.658 466.66 332.553C466.192 332.449 465.902 331.986 466.006 331.517L466.925 326.64L461.983 325.652C461.983 325.652 461.961 325.643 461.952 325.643C461.905 325.63 461.861 325.613 461.814 325.595C461.779 325.582 461.74 325.569 461.705 325.552H461.71Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M462.013 322.795C461.987 322.075 462.551 321.473 463.266 321.451L469.773 321.438C470.371 321.416 470.874 321.884 470.896 322.483C470.896 322.513 470.896 322.539 470.892 322.565H470.896L470.402 329.055C470.38 329.532 469.977 329.905 469.5 329.883C469.023 329.861 468.65 329.458 468.672 328.981L468.72 323.684L463.361 324.052C462.642 324.078 462.039 323.514 462.017 322.799L462.013 322.795Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M465.043 339.884C466.964 339.884 468.52 338.328 468.52 336.407C468.52 334.487 466.964 332.931 465.043 332.931C463.123 332.931 461.567 334.487 461.567 336.407C461.567 338.328 463.123 339.884 465.043 339.884Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M461.228 330.819C460.886 327.334 460.864 325.539 460.994 324.208C461.09 323.224 462 322.908 462.017 322.652C462.052 322.079 462.455 321.594 463.123 321.46C463.465 321.39 463.747 321.386 464.111 320.97L465.23 316.322L466.413 311.974C466.509 311.506 466.968 311.202 467.436 311.298C467.905 311.393 468.208 311.853 468.113 312.321L467.354 316.756L466.374 322.656C466.283 323.419 467.168 325.669 467.71 326.952C467.857 327.303 468.355 327.308 468.507 326.952C469.24 325.262 470.749 321.78 470.939 321.39C471.251 320.753 471.893 319.656 473.619 319.821C473.619 319.821 472.379 324.052 472.023 325.478C471.581 327.243 471.221 330.208 470.74 331.73C470.332 333.013 468.507 336.624 468.507 336.624L461.627 335.961C461.627 335.961 461.397 332.536 461.233 330.828L461.228 330.819Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M469.881 334.682H459.477L447.863 375.46L461.397 378.494L469.881 334.682Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M530.575 381.503C530.575 381.503 540.104 422.298 541.704 430.132C545.085 446.731 552.069 489.685 553.855 498.447C555.819 508.075 563.523 553.184 563.523 553.184H540.98L526.604 486.303C526.604 486.303 516.85 451.348 513.017 437.406C512.753 436.448 511.348 436.613 511.314 437.605C510.867 451.513 509.766 485.549 509.766 485.549V553.179H485.488V485.549C485.449 483.178 482.02 447.399 480.286 417.919C479.371 402.338 488.957 381.503 488.957 381.503H530.575Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M498.412 315.594V315.585C498.633 316.981 498.941 318.225 499.361 319.071C500.332 321.017 501.763 322.673 502.829 323.753V336.412C502.829 340.244 505.933 343.348 509.766 343.348C513.598 343.348 516.702 340.244 516.702 336.412V323.853C517.734 322.773 519.165 321.078 520.17 319.066C520.591 318.23 520.899 316.986 521.129 315.581V315.59C524.024 315.59 523.652 306.069 523.652 306.069C523.652 305.588 523.262 305.194 522.776 305.194H521.779C521.861 304.626 521.905 304.049 521.905 303.46C521.905 296.757 516.468 291.321 509.766 291.321C503.064 291.321 497.627 296.757 497.627 303.46C497.627 304.049 497.67 304.626 497.753 305.194H496.769C496.288 305.194 495.893 305.584 495.893 306.069C495.893 306.069 495.512 315.59 498.412 315.59V315.594Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M538.999 341.493C538.812 340.816 538.53 340.192 538.171 339.633C538.526 340.197 538.808 340.821 538.999 341.493Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M495.026 304.335C495.026 296.194 501.624 289.595 509.766 289.595C517.908 289.595 524.506 296.194 524.506 304.335C524.506 304.569 524.488 326.012 524.488 326.012C524.488 327.928 522.936 329.48 521.02 329.48H498.512C496.595 329.48 495.043 327.928 495.043 326.012C495.043 326.012 495.026 304.569 495.026 304.335Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M453.113 383.744C455.558 384.29 457.986 383.471 459.611 381.793V381.802C459.611 381.802 474.022 366.932 478.864 361.942C479.861 360.915 481.305 359.428 482.874 357.806C485.428 368.805 488.957 381.503 488.957 381.503C488.957 381.503 487.426 384.889 486.902 386.241C486.364 387.633 484.916 391.908 484.916 391.908H532.986L530.575 381.503C530.575 381.503 531.342 378.746 532.418 374.684C534.186 382.379 536.064 390.538 536.064 390.538C536.064 390.538 536.064 390.564 536.081 390.616C536.09 390.646 536.098 390.676 536.103 390.707C536.35 391.773 537.694 397.613 538.396 400.673C539.957 407.436 546.182 430.058 546.182 430.058H558.321C558.321 430.058 555.03 411.082 551.918 397.561C551.185 394.396 549.772 388.257 549.598 387.503C549.585 387.451 549.581 387.425 549.581 387.425C549.581 387.425 544.934 367.249 543.373 360.473C542.263 355.656 539.454 343.457 539.107 341.948C539.085 341.848 539.072 341.796 539.072 341.796C539.051 341.697 539.025 341.592 538.999 341.493C538.808 340.821 538.526 340.197 538.171 339.633C538.162 339.624 538.153 339.611 538.149 339.603C538.053 339.455 537.949 339.308 537.845 339.169C537.659 338.922 537.46 338.692 537.243 338.475C537.173 338.406 537.108 338.341 537.035 338.276C536.965 338.211 536.896 338.146 536.822 338.085C536.606 337.899 536.376 337.725 536.137 337.569C536.077 337.526 536.012 337.487 535.951 337.448C535.851 337.387 535.747 337.327 535.647 337.275C535.153 336.997 534.629 336.785 534.095 336.646C529.136 335.358 519.78 332.948 516.702 332.948H502.829C499.756 332.948 490.396 335.358 485.436 336.646C485.415 336.65 485.393 336.659 485.371 336.668C485.207 336.711 485.042 336.763 484.881 336.819C484.777 336.858 484.669 336.902 484.561 336.945C484.457 336.988 484.353 337.036 484.249 337.084C484.153 337.127 484.062 337.175 483.971 337.223C483.893 337.262 483.815 337.305 483.737 337.357C483.668 337.396 483.603 337.435 483.538 337.478C483.299 337.621 483.065 337.79 482.844 337.973C482.783 338.02 482.727 338.072 482.666 338.124C482.519 338.246 482.38 338.38 482.241 338.523C482.241 338.523 482.22 338.545 482.176 338.592C481.314 339.481 472.292 348.802 468.945 352.253C464.068 357.282 449.653 372.143 449.653 372.143H449.662C448.795 373.036 448.153 374.163 447.863 375.46C447.026 379.197 449.376 382.907 453.113 383.744Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M236.272 208.092V520.231H264.017"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M268.543 527.168L270.806 568.786H307.01L309.273 527.168"
      fill="#F3F3F3"
    />
    <path
      d="M268.543 527.168L270.806 568.786H307.01L309.273 527.168"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M259.491 561.997L264.017 564.26V568.786H254.965L259.491 561.997Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M266.28 520.231L270.806 508.916L284.384 513.442L291.173 520.231"
      fill="#F3F3F3"
    />
    <path
      d="M266.28 520.231L270.806 508.916L284.384 513.442L291.173 520.231"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path d="M309.273 520.231V508.916H293.436L291.173 515.705" fill="#F3F3F3" />
    <path
      d="M309.273 520.231V508.916H293.436L291.173 515.705"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M273.069 520.231L282.121 515.705L284.384 517.968L291.173 515.705L301.244 524.176"
      fill="#F3F3F3"
    />
    <path
      d="M273.069 520.231L282.121 515.705L284.384 517.968L291.173 515.705L301.244 524.176"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M313.799 520.231H264.017V527.168H313.799V520.231Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M749.566 83.237H610.838V152.601H749.566V83.237Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M749.567 138.728H680.202V152.601H749.567V138.728Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M683.671 145.665H711.416"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M742.582 90.8584L742.266 90.5376L740.757 92.0462L739.253 90.5376L738.932 90.8584L740.441 92.3627L738.932 93.8714L739.253 94.1879L740.757 92.6835L742.266 94.1879L742.582 93.8714L741.078 92.3627L742.582 90.8584Z"
      fill="black"
    />
    <path
      d="M621.243 93.6416H690.607"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M621.243 100.578H701.012"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M621.243 107.514H676.734"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M613.301 101.883C622.878 101.883 630.642 94.1191 630.642 84.5419C630.642 74.9647 622.878 67.2009 613.301 67.2009C603.723 67.2009 595.96 74.9647 595.96 84.5419C595.96 94.1191 603.723 101.883 613.301 101.883Z"
      fill="#F3F3F3"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M607.517 78.763L619.079 90.3208"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M619.079 78.763L607.517 90.3208"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M555.347 117.919H610.838"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M704.48 152.601V339.884"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
    <path
      d="M520.665 83.237V0"
      stroke="black"
      strokeWidth="0.894136"
      strokeMiterlimit="10"
    />
  </g>
  <defs>
    <clipPath id="clip0_0_2401">
      <rect width="750" height="569.22" fill="white" />
    </clipPath>
  </defs>`;

export const error403SVG = html`<svg
  class=${`${blockClass}__svg ${blockClass}__403`}
  viewBox="0 0 750 570"
  fill="none"
  aria-hidden="true"
  xmlns="http://www.w3.org/2000/svg"
>
  ${innerSVG}
</svg>`;
